import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';

import { useAssignVerificationDesignOutput } from '../Product.hooks';
import {
  ProductDesignOutput,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignDesignOutputDialog from './AssignDesignOutputDialog';

export type VerificationAssignDesignOutputDialogProps = BaseProductAssignDialogProps<'verificationId'>;

const VerificationAssignDesignOutputDialog: React.FC<VerificationAssignDesignOutputDialogProps> = (
  props: VerificationAssignDesignOutputDialogProps
) => {
  const {
    open,
    productId,
    verificationId,
    selectedItems,
    onCancel,
    onError,
    onAssigned
  } = props;
  const {
    updatedProductVerification,
    isAssigning,
    error: assignError,
    assignDesignOutputs
  } = useAssignVerificationDesignOutput(productId, verificationId);

  // handle notification to parent after assigning
  useEffect(() => {
    if (updatedProductVerification) {
      onAssigned?.(updatedProductVerification);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedProductVerification]);

  useEffect(() => {
    if (assignError) {
      onError?.(assignError);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignError]);

  return (
    <AssignDesignOutputDialog
      {...{ open, productId, selectedItems, onCancel, onError }}
      isLoading={isAssigning}
      contentText={`Search for ${getProductEntityName(
        'designOutput'
      )} to assign to the Verification.`}
      onSubmit={(designOutputs: ProductDesignOutput[]) => {
        assignDesignOutputs({
          designOutputIds: designOutputs.map(
            (designOutput: ProductDesignOutput) => designOutput.id
          )
        });
      }}
    />
  );
};

export default VerificationAssignDesignOutputDialog;
